import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Params } from '@angular/router';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';
import { RouterStateService } from '@quorum/sha-router';
import { CustomValidators } from '@quorum/sha-validators';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'svc-appointments-list-filter',
  templateUrl: './appointments-list-filter.component.html',
  styleUrls: ['./appointments-list-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentsListFilterComponent implements OnInit, OnDestroy {
  @Input() appointmentFilterDropdowns$: Observable<any>;
  @Output() filtersChanged: EventEmitter<any> = new EventEmitter<any>();
  routerState$: Subscription;
  defaultAppointmentFilterValues: any = {
    appointmentDateFrom: new Date(),
    appointmentDateTo: new Date(),
    myAppointmentsToggle: false,
  };

  appointmentFilterForm: FormGroup = this.formBuilder.group(this.defaultAppointmentFilterValues, {
    validators: CustomValidators.dateRangeValidator('appointmentDateFrom', 'appointmentDateTo'),
  });

  maxAppointmentDate: Date = new Date(new Date().setFullYear(new Date().getFullYear() + 5));
  appointmentFilterSub: Subscription;
  constructor(
    private serviceLaneFacade: ServiceLaneFacade,
    private routerStateService: RouterStateService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.routerState$ = combineLatest([
      this.routerStateService.selectRouterState().pipe(take(1)),
      this.serviceLaneFacade.appointmentFilters$.pipe(take(1)),
    ]).subscribe(([routerState, appointmentFilters]) => {
      const queryParams: Params = routerState.state.root.queryParams;
      if (this.serviceLaneFacade.isEmpty(queryParams)) {
        this.appointmentFilterForm.patchValue({
          ...appointmentFilters,
        });
      } else {
        this.appointmentFilterForm.patchValue({
          ...queryParams,
          transportOptionId: queryParams.transportOptionId ? Number(queryParams.transportOptionId) : null,
          myAppointmentsToggle: appointmentFilters.myAppointmentsToggle,
        });
      }
    });
  }

  ngOnDestroy() {
    this.routerState$.unsubscribe();
  }

  apply(formValue: any) {
    this.filtersChanged.emit(formValue);
  }
}
